import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=407baca1&scoped=true&"
import script from "./CustomerSearch.vue?vue&type=script&lang=js&"
export * from "./CustomerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407baca1",
  null
  
)

export default component.exports